/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGenderNeutrois = createReactComponent("gender-neutrois", "IconGenderNeutrois", [
  ["path", { d: "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", key: "svg-0" }],
  ["path", { d: "M12 10v-7", key: "svg-1" }]
]);

export { IconGenderNeutrois as default };
//# sourceMappingURL=IconGenderNeutrois.js.map
